<template>
  <div class="ts-app-shell_fh">
    <div class="ts-app-landing-dashboard">
      <br />
      <div class="padd-main">
        <el-row :gutter="20">
          <el-col :span="5" style="text-align: center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="completeChecklist">
                <h6 class="card-font">WIOA <br />Checklist</h6>
                <div class="dash-card">
                  <i class="fas fa-clipboard-check"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24">
            <br />
            <h6 class="card-font">WIOA Checklist</h6>
            <br />
            <p>
              Complete your WIOA Checklist to show your eligibility for
              programs.
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5" style="text-align: center">
            <el-card :body-style="{ padding: '0px' }" shadow="hover">
              <div class="card-body" @click="getWioaStatus">
                <h6 class="card-font">WIOA <br />Status</h6>
                <div class="dash-card">
                  <i class="fas fa-info-circle"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :xl="15" :lg="15" :md="24" :sm="24" :xs="24">
            <br />
            <h6 class="card-font">WIOA Status</h6>
            <br />
            <p>
              Check the status of your WIOA application.
            </p>
          </el-col>
        </el-row>
        <el-dialog
          style="z-index: 1000"
          :visible="showInprogressChecklistDialog"
          :show-close="true"
          width="650px"
        >
          <div slot="title">
            <el-row style="margin-bottom: 0px !important">
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :xs="24"
                :sm="24"
                style="height: 80px; padding: 15px 0px 15px 0px; text-align: center;"
              >
                <span style="font-size: 25px;"
                  >You still need to Complete your WIOA Checklist!
                </span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0px !important">
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :xs="24"
                :sm="24"
                style="height: 80px; text-align: center"
              >
                <img src="../../../assets/img/wioa-high-importance.png" />
              </el-col>
            </el-row>
          </div>

          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="onCloseInprogressChecklistDialog(null)"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </el-dialog>
      </div>
    </div>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: { TSLoading },
  data() {
    return {
      showInprogressChecklistDialog: false,
      loading: false,
      checklistUpdateRequestModal: false,
      updateRequest: {
        requestDetails: null
      },
      modelState: {},
      createChecklistDisabled: false
    };
  },
  created() {},
  computed: {
    currentUser() {
      debugger;
      return this.$store.state.account.current_user;
    }
  },
  methods: {
    onCloseInprogressChecklistDialog() {
      this.showInprogressChecklistDialog = false;
    },
    completeChecklist() {
      this.loading = true;
      this.loading = true;
      this.$store
        .dispatch("wioa/hasChecklistRequest", this.currentUser.id)
        .then(res => {
          if (res) {
            this.$store
              .dispatch("wioa/getCheckliStstatusByClient", this.currentUser.id)
              .then(res => {
                debugger;
                if (
                  res.checklistStatusId == 0 ||
                  res.checklistStatusId == 3 ||
                  res.checklistStatusId == 5
                ) {
                  this.$router.push({ name: "WioaChecklist" });
                  if (res.checklistStatusId == 0)
                    localStorage.setItem("editChecklist", res.checklistId);
                } else {
                  this.showMessagePopup(
                    "WIOA Checklist",
                    "﻿You already have a pending WIOA checklist. This feature is not accessible for the meantime.",
                    "error"
                  );
                }
              })
              .catch(() => {
                //if no records found
                this.$router.push({ name: "WioaChecklist" });
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.showMessagePopup(
              "WIOA Checklist",
              "You don't have a request to complete WIOA checklist. This feature is not accessible for the meantime.",
              "error"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getWioaStatus() {
      this.loading = true;
      this.$store
        .dispatch("wioa/getCheckliStstatusByClient", this.currentUser.id)
        .then(res => {
          debugger;
          this.clientNames = res;
          if (res.checklistStatusId == 0) {
            this.showInprogressChecklistDialog = true;
          } else {
            this.$router.push({ name: "WioaStatus" });
          }
        })
        .catch(() => {
          this.showInprogressChecklistDialog = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showMessagePopup(title, msg, type, then) {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => (then && then()) || false);
    }
  }
};
</script>
